__turbopack_context__.v({
  "body": "drawer-module__SOupwa__body",
  "content": "drawer-module__SOupwa__content",
  "header": "drawer-module__SOupwa__header",
  "title": "drawer-module__SOupwa__title",
});
